import styled from 'styled-components';

// Matches the standard Profile question styling (no bordered box; grey prompt).
export const ProviderPreferenceQuestionWrapper = styled.div`
  .question {
    .paragraph {
      margin-bottom: var(--sizing-sm);
    }

    /* Flows with the question text so it stays on the last line, per the design. */
    .tip {
      display: inline-flex;
      vertical-align: text-bottom;
      margin-left: var(--sizing-xs);
      cursor: pointer;
    }
  }
`;
